<section class="thankyou-message">
  <div class="thankyou-message__box cmnh-card simple">
    <div class="card-body">
      <h1 class="thankyou-message__title">Thanks for your donation!</h1>
      <h4 class="thankyou-message__text">
        If you would like to make another donation, please click
        <a href="" class="thankyou-message__link" (click)="refreshPage($event)">Here</a>
        or reload the page.
      </h4>
    </div>
  </div>
</section>
